const currency = {
  USD: [
    'AR',
    'BO',
    'BR',
    'BS',
    'BZ',
    'CA',
    'CL',
    'CO',
    'CR',
    'CU',
    'DO',
    'EC',
    'GF',
    'GT',
    'GY',
    'HN',
    'HT',
    'JM',
    'MX',
    'NI',
    'PA',
    'PE',
    'PR',
    'PY',
    'SR',
    'SV',
    'US',
    'UY',
    'VE',
    'AU',
    'NZ'
  ],
  GBP: ['GB'],
  EUR: []
}

export const currencyToSymbolMap: { [key: string]: string } = {
  EUR: '€',
  USD: '$',
  GBP: '£'
}

export const getCurrency = (countryCode: string) => {
  const currencyKey = Object.keys(currency).find((item) => {
    if (item === 'GBP' || item === 'USD') {
      // @ts-ignore
      return currency[item].includes(countryCode)
    }
    return false
  })

  return currencyKey ?? 'EUR'
}
